import { Box, Typography } from '@mui/material';
import React from 'react';
import EllipsisText from '../../../components/EllipsisText';
import I18n from '../../../i18n/I18n';

const titleSuffixSx = { color: 'text.secondary' };

export interface CreateApprovalFormEditablePanelHeaderProps {
    titleToken: string;
    titleSuffix?: string;
}

export default function CreateApprovalFormEditablePanelHeader({
    titleToken,
    titleSuffix
}: CreateApprovalFormEditablePanelHeaderProps) {
    return (
        <Box flex={1} display={'inline-flex'} alignItems={'center'} gap={1}>
            <Typography color="primary" textTransform="uppercase">
                <I18n token={titleToken} />
            </Typography>
            {titleSuffix && <EllipsisText text={`(${titleSuffix})`} sx={titleSuffixSx} />}
        </Box>
    );
}
